/**
 * BUNKER 84 — cartridge palette.
 *
 * '80s underground-bunker corridor shooter. Wolfenstein 3D heritage filtered
 * through sodium-vapor amber + cold-concrete grey. The hero color is the
 * amber emergency lamp glow that bleeds across every wall — it's how the
 * player keeps their bearings in the gloom.
 *
 * Color logic
 * -----------
 * - WALLS = cool concrete greys + warm amber where lit. The brightest wall
 *   tone reads as "lit by a hallway lamp"; the dark tone reads as "shadow
 *   side of the corner." NS/EW shading uses these two against each other.
 * - FLOOR = darker concrete; CEILING = near-black with a faint amber haze
 *   to imply the lamp above.
 * - ENEMIES = monochrome cold-steel grey jumpsuits with a single red accent
 *   (insignia, eyepiece). Reads instantly against the amber walls.
 * - WEAPON = gunmetal silhouette, white-hot muzzle flash.
 * - HUD = amber on near-black; health drains amber → red as it falls.
 */

// ---- Walls (8 types — index matches map tile id) ----
export const WALL_CONCRETE_LIT = '#a07848';     // primary corridor wall (lit side)
export const WALL_CONCRETE_DARK = '#5c4628';    // shadow side of concrete
export const WALL_STEEL_LIT = '#788090';        // riveted steel panel
export const WALL_STEEL_DARK = '#444a58';
export const WALL_BRICK_LIT = '#8c5430';        // red-clay brick passage
export const WALL_BRICK_DARK = '#502c18';
export const WALL_TILE_LIT = '#9098a8';         // cold white-grey utility tile
export const WALL_TILE_DARK = '#525866';
export const WALL_DOOR_LIT = '#c08038';         // sliding door (orange-stained steel)
export const WALL_DOOR_DARK = '#704818';
export const WALL_DOOR_LOCKED_LIT = '#a82828';  // locked door (red accent)
export const WALL_DOOR_LOCKED_DARK = '#5c1414';
export const WALL_SECRET_LIT = '#a07848';       // visually identical to concrete
export const WALL_SECRET_DARK = '#5c4628';
export const WALL_INSIGNIA_LIT = '#604030';     // wall with insignia plate
export const WALL_INSIGNIA_DARK = '#382418';

// ---- Floor / ceiling ----
export const CEILING = '#1a1410';                // near-black with amber bias
export const FLOOR = '#2c241c';                  // dark dust-concrete

// ---- Distance fog ----
export const FOG_FAR = '#0c0806';                // walls fade toward this

// ---- HUD ----
export const HUD_BG = '#0c0806';
export const HUD_FRAME = '#604028';
export const HUD_TEXT = '#ffb060';               // amber readout
export const HUD_SCORE = '#ffd070';
export const HUD_HP_FULL = '#ffb060';
export const HUD_HP_LOW = '#ff4030';
export const HUD_AMMO = '#c8c8d4';

// ---- Title / cards ----
export const TITLE_BG = '#0a0806';
export const TITLE_TEXT = '#ffb060';
export const TITLE_SUBTEXT = '#a07848';
export const CARD_BG = '#0a0806';
export const CARD_BORDER = '#604028';

/**
 * Tokens the cabinet samples for marquee tinting while this cartridge
 * is loaded. First entry = signature color (amber emergency-lamp glow).
 */
export const PALETTE_HINT: readonly string[] = [
  HUD_TEXT,           // amber — the bunker's signature glow
  WALL_STEEL_LIT,     // cool steel — the cold-side counterpoint
  HUD_HP_LOW,         // red accent — enemies + danger
  CEILING,            // near-black — the gloom
];
